import {
  DataStoreModel,
  ModelTypes,
} from '../../dataStorePersistence/DataStoreModel';

export enum Role {
  ADMIN = 'ADMIN',
  MD = 'MD',
  USER = 'USER',
}

export interface UserCredentials {
  email: string;
  password: string;
}

export interface User extends DataStoreModel {
  readonly accountId?: string;
  readonly accountType?: string;
  readonly email: string;
  readonly phone: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly postalCode: string;
  readonly inviteEmailStatus: string;
  readonly role: Role;
  readonly enabled: boolean;
}

export interface UserBackend extends DataStoreModel {
  readonly accountId?: string;
  readonly email: string;
  readonly phone: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly postalCode: string;
  readonly role: Role;
  readonly inviteEmailStatus: string;
  readonly enabled: boolean;
}

export interface CreateUserInput {
  readonly accountId?: string;
  readonly email: string;
  readonly phone: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly postalCode: string;
  readonly role: Role;
  readonly inviteEmailStatus: string;
  readonly enabled: boolean;
}

export interface UpdateUserInput {
  id: string;
  role?: Role;
  enabled?: boolean;
  phone?: string;
  // QUESTION: should we allow this backend? maybe we want other events on delete than on update?
  // _deleted?: boolean;
}
